class MatQuizEmail extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      form: this.querySelector("form"),
      btn: this.querySelector('button[type="button"]'),
      submitBtn: this.querySelector('button[type="submit"]'),
      emailInput: this.querySelector('input[type="email"]'),
      matQuiz: document.querySelector("mat-quiz"),
    };
  }

  connectedCallback() {
    this.attachKlaviyoForm();
    // this.elements.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.elements.btn.addEventListener("click", this.onFormSubmit.bind(this));
  }

  attachKlaviyoForm() {
    if (this.elements.form == null) {
      return;
    }

    window.KlaviyoSubscribe.attachToForms(`#${this.elements.form.id}`, {
      hide_form_on_success: true,
      $source: "mat-quiz",
    });
  }

  onFormSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const productResultsData = this.elements.matQuiz._state.productResultsData;
    const scoringData = this.elements.matQuiz._state.scoringData;
    const userCustomProperties =
      this.elements.matQuiz._state.userCustomProperties;
    const _learnq = window._learnq || [];
    const locale = window.matQuiz.locale;

    const data = {
      Name: [],
      "Image URL": [],
      URL: [],
      Score: [],
      "Help Text": [
        locale.results_page.match_1,
        locale.results_page.match_2,
        locale.results_page.match_3,
      ],
    };
    const profile = {
      $email: this.elements.emailInput.value,
      $source: "mat-quiz",
    };

    // Set up data for tracking event
    for (let index = 0; index < productResultsData.length; index++) {
      const product = productResultsData[index];
      const points = scoringData.find(
        (score) => score.handle === product.handle
      ).points;
      data.Name.push(product.title);
      data["Image URL"].push(`https:${product.featured_image}`);
      data.URL.push(window.matQuiz.shopUrl + product.url);
      data.Score.push(points);
    }

    // Set up profile custom properties
    userCustomProperties.forEach((prop) => {
      profile[prop.label] = prop.answer;
    });

    _learnq.push(["identify", profile]);

    setTimeout(() => {
      _learnq.push(["track", "Filled Out Survey", data]);
    }, 1000);

    this.elements.submitBtn.click();
  }
}

customElements.define("mat-quiz-email", MatQuizEmail);